export default __webpack_public_path__ + "media/titles/title_6_locale_pt-20e62452.png";